module.exports = __webpack_public_path__ + "img/Apple-WWDC23-Vision-Pro-glass-230605.jpg.landing-big_2x.d7f0d3bf.jpg";